import { Component, Inject, Optional, OnInit } from '@angular/core'; 
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-no-city',
	templateUrl: './no-city.component.html',
	styleUrls: ['./no-city.component.css']
})
export class NoCityComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<NoCityComponent>,
    	@Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

	ngOnInit() {}

	closeDialog(pickCity: boolean = false) { 
		this.dialogRef.close({event:'close', data: {pickCity: pickCity}});
	}

}
